import { getAiModelOption, getAiModelOptions, getDefaultAiModelId, type AiTaskModelId } from "../ai/tasks";

export type TraineeAiReportModelOptionId = AiTaskModelId<"traineeReport">;
export type TraineeAiReportModelOption = ReturnType<typeof getTraineeAiReportModelOption>;
export const defaultTraineeAiReportModelOptionId = getDefaultAiModelId("traineeReport");
export const traineeAiReportModelOptions = getAiModelOptions("traineeReport");
export const getTraineeAiReportModelOption = (id?: string | null) => getAiModelOption("traineeReport", id);
